import { ServiceResult } from "@/common/HttpService/statement";
export enum ProjectType {
  /** 进项 */
  Entry = 1,
  /** 销项 */
  Sales
}
export enum OrganizationType {
  /** 项目 */
  Project = 11,
  /** 公司 */
  Company,
  /** 部门 */
  Department
}

export interface ProjectInfoResult extends ServiceResult<ProjectInfo[]> {}
export interface InvoiceSimpleInfoResult extends ServiceResult<InvoiceSimpleInfo[]> {}
export interface InvoiceInfoResult extends ServiceResult<InvoiceInfo[]> {}
export interface InvoiceDetailInfoResult extends ServiceResult<InvoiceDetailInfo[]> {}
export interface InvoiceDetailResult extends ServiceResult<InvoiceDetail[]> {}

export interface ProjectInfo {
  id: string,
  code: string,
  disable: boolean,
  /** 公司所在位置 */
  fullName: string,
  name: string,
  parentId: string,
  /** 组织类型或项目，if type === 项目 */
  type: OrganizationType
}

export interface InvoiceSimpleInfo {
  id: string,
  /** 当前发票所属项目 */
  projectName: string,
  organizationName: string,
  showName: string,
  invoiceDate: string,
  totalTaxSum: string
  type: string
}

export interface InvoiceInfo {
  invoiceTypeName : string;
  invoiceAmount : string;
  tax : string;
  totalTaxSum : string;
  invoiceCode : string;
  serialNumber : string;
  invoiceDate : string;
  checkCode : string;
  billToUnit: string;
  billToUnitNumber : string;
  billToUnitAddress : string;
  billToUnitPhone : string;
  billToUnitOpeningBank : string;
  billToUnitAccountNumber : string;
  invoiceUnit : string;
  invoiceUnitNumber : string;
  invoiceUnitAddress : string;
  invoiceUnitPhone : string;
  invoiceUnitOpeningBank : string;
  invoiceUnitAccountNumber : string;
  details : InvoiceDetail[]
}

export interface InvoiceDetail {
  name : string;
  notTariffPrice : string;
  taxRate : string;
  taxes : string;
}

export interface InvoiceDetailInfo extends InvoiceInfo {
  id: string
  projectId: string
  projectName: string
  organizationId: string
  organizationName: string
}

export interface InvoiceByHandParams {
  /**
   * 发票代码（长度10位或者12位）
   */
  invoiceCode: string
  /**
   * 发票号码（长度8位）
   */
  invoiceNumber: string
  /**
   * 开票时间（时间格式必须为：2017-05-11，不支持其他格式）           
   */
  billTime: string
  /**
   * 校验码（检验码必须是后六位！，增值税专用发票，增值税机动车发票，二手车统一发票可以不传）           
   */
  checkCode?: string
  invoiceAmount?: string
}

export interface SubmitInvoiceByHandParams extends InvoiceByHandParams {
  organizationId: string
  projectId: string
}


// WEBPACK FOOTER //
// ./src/AppStore/SmartMoney/statement.ts